import styled from 'styled-components';
import { rem } from 'polished';
import { StepNavigationStyled } from '@components/v2/StepNavigation/StepNavigationStyled';

export const StepNavigationStyledAP = styled(StepNavigationStyled)`
    .closed,
    .opened {
        background: ${({ theme }) => theme.colors.grey8};

        .wrapper {
            .blurryHolder {
                &.isRight {
                    right: -5px;
                }
                &.isLeft {
                    left: -7px;
                }

                .icon-wrapper {
                    position: absolute;
                    z-index: 999;

                    svg {
                        filter: blur(-5px);

                        path {
                            fill: ${({ theme }) => theme.colors.black};
                        }
                    }
                }
            }
        }

        .contactUsContainer {
            .contactUsNumber {
                font-size: ${rem(12)};
                color: ${({ theme }) => theme.colors.black};
                font-weight: bold;
                cursor: text;
            }
        }
    }
`;
